import { tabsAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

import { colours } from "@/theme/colours";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(tabsAnatomy.keys);

const baseStyle = definePartsStyle({
	fontFamily: "buttons",
	tab: {
		fontWeight: "regular",
	},
	tabpanels: {
		width: "100%",
		height: "100%",
	},
	tabpanel: {
		width: "100%",
		height: "100%",
	},
});

export const tabsTheme = defineMultiStyleConfig({
	baseStyle: baseStyle,
	variants: {
		line: {
			tablist: {
				borderBottom: `2px solid ${colours.neutrals[300]}`,
			},
			tab: {
				p: "16px",
				borderRadius: "4px 4px 0 0",
				position: "relative",
				borderBottom: `2px solid transparent`,

				_before: {
					content: '""',
					transition: ".5s ease",
					position: "absolute",
					bgColor: "brand.400",
					top: "100%",
					bottom: "0",
					left: "0",
					right: "0",
					transform: "scaleY(0)",
				},

				_after: {
					content: '""',
					transition: ".2s ease",
					position: "absolute",
					bgColor: `${colours.brand[400]}10`,
					top: "100%",
					bottom: "0",
					left: "0",
					right: "0",
				},

				_focus: {
					borderBottom: `2px solid ${colours.brand[400]}`,
				},
				_active: {
					borderRadius: "4px 4px 0 0",
				},
				_selected: {
					transition: "200ms ease",
					borderBottom: `2px solid ${colours.brand[400]}`,
					marginBottom: "-2px",
					_after: {
						top: "0",
						transform: "scaleY(1)",
					},
				},
			},
			indicator: {
				bg: "brand.400",
				width: "100%",
				height: "2px",
			},
		},
		rounded: {
			tablist: {
				display: "inline-flex",
				bg: "neutrals.300",
				borderRadius: "xl",
			},
			tab: {
				m: "4px",
				borderRadius: "xl",
				p: "12px 24px",
				_focus: {
					boxShadow: "sm",
					bg: "neutrals.0",
				},
				_active: {
					bg: "neutrals.0",
				},
				_selected: {
					boxShadow: "sm",
					bg: "neutrals.0",
				},
			},
		},
		enclosed: {
			tablist: {
				display: "flex",
				bg: "transparent",
			},
			tab: {
				m: "4px",
				mb: "0px",
				borderTopStartRadius: "sm",
				borderTopEndRadius: "sm",
				p: "12px 24px",
				position: "relative",

				_after: {
					content: '""',
					transition: ".2s ease",
					position: "absolute",
					bgColor: `${colours.neutrals[0]}10`,
					top: "100%",
					bottom: "0",
					left: "0",
					right: "0",
				},

				_focus: {
					boxShadow: "sm",
					bg: "neutrals.0",
				},
				_active: {
					bg: "neutrals.0",
				},
				_selected: {
					boxShadow: "sm",
					bg: "neutrals.0",
					transition: "200ms ease",
					_after: {
						top: "0",
						transform: "scaleY(1)",
					},
				},
			},
			tabpanels: {
				bg: "neutrals.0",
			},
		},
		removable: {
			tablist: {
				borderBottom: `2px solid ${colours.neutrals[500]}`,
			},
			tab: {
				p: "12px 24px",
				bg: "neutrals.300",
				marginRight: "4px",
				borderRadius: "4px 4px 0 0",
				_focus: {
					boxShadow: "sm",
					bg: "neutrals.500",
					color: "neutrals.0",
				},
				_active: {
					bg: "neutrals.500",
					color: "neutrals.0",
				},
				_selected: {
					bg: "neutrals.500",
					color: "neutrals.0",
				},
			},
		},
	},
	defaultProps: {
		variant: "line",
	},
});
